module.exports = __webpack_public_path__ + "img/zhichi (1).eaa33ce1.png";